import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
    consentForms: [],
    consentFormDisplay: [],
    savedForms: [],
    draftedForms: [],
};

const fetchForms = (state, action) => {
    const { forms } = action;
    return updateObject(state, {
        consentForms: forms,
    });
};

const fetchForm = (state, action) => {
    const { form } = action;

    return updateObject(state, {
        consentFormDisplay: form,
    });
};

const saveDraft = (state, action) => {
    const { form } = action;

    return updateObject(state, {
        draftedForms: [...state.draftedForms, form],
    });
};

const saveForm = (state, action) => {
    const { form } = action;

    return updateObject(state, {
        savedForms: [...state.savedForms, form],
    });
};

const clearForm = (state, action) => {
    return updateObject(state, {
        draftedForms: [],
        consentFormDisplay: [],
        savedForms: [],
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_FORMS:
            return fetchForms(state, action);
        case actionTypes.FETCH_FORM:
            return fetchForm(state, action);
        case actionTypes.SAVE_FORM:
            return saveForm(state, action);
        case actionTypes.SAVE_DRAFT:
            return saveDraft(state, action);
        case actionTypes.CLEAR_FORM:
            return clearForm(state, action);

        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/formBuilder.js